function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M18.573 6.897h.093l-.057-.047 3.517-3.58.008-.065A11.284 11.284 0 0011.283.783C7.498 1.938 4.567 5 3.53 8.884c.06-.025.122-.046.184-.063a8.086 8.086 0 016.113-1.234.105.105 0 01.075-.02 6.264 6.264 0 018.686-.672h-.019"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M25.641 8.885a11.733 11.733 0 00-3.455-5.67l-3.575 3.634a6.513 6.513 0 012.33 5.131v.644c4.237 0 4.237 6.472 0 6.472h-6.356l-.01.01v5.136h-.026l.037.038h6.357c3.647.03 6.883-2.375 7.965-5.92 1.082-3.547-.245-7.396-3.267-9.475"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M8.22 24.24h6.354v-5.177H8.22c-.45 0-.896-.1-1.305-.292L3.24 22.512l-.01.04a8.134 8.134 0 004.991 1.691"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M8.215 7.437c-3.527.026-6.65 2.328-7.774 5.732-1.125 3.404-.005 7.16 2.79 9.352l3.692-3.754c-1.292-.59-2.045-1.977-1.848-3.404.197-1.428 1.297-2.55 2.699-2.753a3.167 3.167 0 013.346 1.876l3.688-3.753a8.209 8.209 0 00-6.593-3.296"
}));

function SvgColorLogoGcp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.008762270212173462 0.29384422302246094 29.272241592407227 23.986434936523438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorLogoGcp);
export default __webpack_public_path__ + "static/media/color_logo_gcp.8ab8334f.svg";
export { ForwardRef as ReactComponent };